/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PropertyTypeEnum {
    METRIC = 'METRIC',
    FIELD = 'FIELD',
    DOCUMENT = 'DOCUMENT',
    LINE_ITEM = 'LINE_ITEM',
    DATABASE_COLUMN = 'DATABASE_COLUMN',
    ASSET_ACCOUNT = 'ASSET_ACCOUNT',
    ASSET_ACCOUNT_FEATURE = 'ASSET_ACCOUNT_FEATURE',
    COVENANT = 'COVENANT',
    COVENANT_FEATURE = 'COVENANT_FEATURE',
    DELIVERABLE = 'DELIVERABLE',
    DELIVERABLE_FEATURE = 'DELIVERABLE_FEATURE',
    FORMULA = 'FORMULA',
    CASHFLOW = 'CASHFLOW',
    CASHFLOW_FORMULA = 'CASHFLOW_FORMULA',
    ROLE = 'ROLE',
    EXPRESSION = 'EXPRESSION',
    VIRTUAL = 'VIRTUAL',
}
